import {
  GET_POLICY_BY_TRACKING_NUMBER_SUCCESS,
  GET_POLICY_BY_TRACKING_NUMBER_FAILED,
  STOCK_IN_WAREHOUSE_RECORDS_SUCCESS,
  STOCK_IN_WAREHOUSE_RECORDS_FAILED,
  TOGGLE_STAGING_RECORD_MODAL,
  UPDATE_STAGING_RECORD,
  CREATE_STAGING_RECORD_SUCCESS,
  CREATE_STAGING_RECORD_FAILED,
} from '../constants'

const initialState = {
  policies: '',
  error: '',
  success: '',
  warehouseRecords: {},
  openStagingRecordModal: false,
  newStagingRecord: {
    trackingNumber: "",
    shelfId: "",
    warehouseNote: "",
    customerName: "",
    customerPhone: "",
    images: [],
  }
}

function stockIn(state = initialState, action) {
  switch (action.type) {
    case GET_POLICY_BY_TRACKING_NUMBER_SUCCESS:
      return {
        ...state,
        policies: action.payload
      }
    case GET_POLICY_BY_TRACKING_NUMBER_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case STOCK_IN_WAREHOUSE_RECORDS_SUCCESS:
      return {
        ...state,
        warehouseRecords: {
          ...state.warehouseRecords,
          [action.payload.policyId]: action.payload.data
        }
      }
    case UPDATE_STAGING_RECORD:
      return {
        ...state,
        newStagingRecord: action.payload
      }
    case TOGGLE_STAGING_RECORD_MODAL:
      return {
        ...state,
        openStagingRecordModal: action.payload.open,
        newStagingRecord: action.payload.data
      }
    case CREATE_STAGING_RECORD_SUCCESS:
      return {
        ...state,
        success: action.payload
      }
    case CREATE_STAGING_RECORD_FAILED:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default stockIn



// WEBPACK FOOTER //
// ./src/modules/stockIn.js